"use client";
import type { FC } from "react";

import { Modal, type ModalProps } from "antd";

interface Props extends ModalProps {
  open: boolean;
  handleOpen: (open: boolean) => void;
  children: React.ReactNode;
}

export const ModalRoot: FC<Props> = ({
  handleOpen,
  open,
  children,
  ...props
}) => {
  return (
    <>
      <Modal
        onOk={() => handleOpen(true)}
        onCancel={() => handleOpen(false)}
        open={open}
        closeIcon={false}
        footer={null}
        {...props}
      >
        {children}
      </Modal>
    </>
  );
};
